import Switch from "../classes/Switch"

export const switches = [
  new Switch({ alias:"transformador-con-dos-desvenados", svgSrc: "/symbol-assets/TransformadorConDosDevanados.svg", label: "Label for Type 1"}),
  new Switch({ alias:"transformador-alumbrado-publico", svgSrc: "/symbol-assets/TransformadorDeAlumbradoPublico.svg", label: "Label for Type 2"}),
  new Switch({ alias:"transformador-trifasico", svgSrc: "/symbol-assets/TransformadorTrifasicoYDeltaConCincoTaps.svg", label: "Label for Type 3"}),
];
